/**
 * 361 (#980): the customer's trip answers as the admin reads them (booking detail, schedule bar and card, dashboard,
 * CSV). The six purposes match `backend/src/modules/bookings/trip.ts`; a test pins the list.
 */
export const TRIP_PURPOSES = [
  'laundry',
  'meal_with_friends',
  'grocery_shopping',
  'cafe_hopping',
  'uni_project',
  'entertainment',
] as const;
export type TripPurpose = (typeof TRIP_PURPOSES)[number];

export const TRIP_PURPOSE_LABELS: Record<TripPurpose, string> = {
  laundry: 'Laundry',
  meal_with_friends: 'Meal with friends',
  grocery_shopping: 'Grocery shopping',
  cafe_hopping: 'Cafe hopping',
  uni_project: 'Uni project',
  entertainment: 'Entertainment',
};

export interface Trip {
  students: number;
  purpose: TripPurpose;
  food_delivery: boolean;
  /** Present exactly when `food_delivery` is true. */
  non_halal?: boolean;
}

/** A label for a purpose the platform sent, even one this build does not know yet. */
export const purposeLabel = (p: string) => TRIP_PURPOSE_LABELS[p as TripPurpose] ?? p;

/** "3 students · Grocery shopping". */
export const tripSummary = (t: Trip) =>
  `${t.students} ${t.students === 1 ? 'student' : 'students'} · ${purposeLabel(t.purpose)}`;

/** "Food delivery: yes · Non-halal: no", or "Food delivery: no". */
export const deliverySummary = (t: Trip) =>
  t.food_delivery
    ? `Food delivery: yes${t.non_halal === undefined ? '' : ` · Non-halal: ${t.non_halal ? 'yes' : 'no'}`}`
    : 'Food delivery: no';
